import React from 'react'
import { FieldComponent } from 'components/Shared/FieldComponent'
import { useTranslation } from 'react-i18next'
import { CustomWarningMessageText } from 'components/Shared/ErrorMessage'
import { useField } from 'formik'

export default function TranslationsForm ({ fieldName, label, warning }) {
  const { t } = useTranslation()

  return (
    <>
      <LanguageField
        fieldName={`${fieldName}.de`}
        label={t(label, { language: 'DE' })}
        warning={warning}
      />
      <LanguageField
        fieldName={`${fieldName}.en`}
        label={t(label, { language: 'EN' })}
        warning={warning}
      />
      <LanguageField
        fieldName={`${fieldName}.pl`}
        label={t(label, { language: 'PL' })}
        warning={warning}
      />
    </>
  )
}

function LanguageField ({ fieldName, label, warning }) {
  const { t } = useTranslation()
  const [, { error }] = useField(fieldName)

  return (
    <>
      <FieldComponent
        fieldName={fieldName}
        label={label}
      />
      {!error && warning?.show && <CustomWarningMessageText message={t(warning.label)}/>}
    </>
  )
}
